import React from 'react';
import { Link } from 'react-router-dom';

import style from './Error.module.scss';

const ErrorPage = () => (
  <div className={style.center}>
    <p>Sorry, page not found!</p>
    <Link to="/clients">
      <button
        className={style.errorButton}
        type="button"
      >
        Home
      </button>
    </Link>
  </div>
);

export default ErrorPage;
